import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
import ChemicalManagement from './StockManagement/ChemicalManagement';
import styles from './AccountTeamDashboard.module.scss';

export default function AccountTeamDashboard() {
  // const { user, userInfo } = useAuth();
  // const navigate = useNavigate();

  return (
    <div className={styles.dashboard}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.titleSection}>
            <h1>Account Team Dashboard</h1>
            {/* <div className={styles.userInfo}>
              <span>Role: {userInfo?.role || user?.role || 'ACCOUNTS'}</span>
              <button 
                className={styles.backButton}
                onClick={() => navigate('/dashboard')}
              >
            Back to Dashboard
          </button>
        </div> */}
      </div>
                </div>
              </div>


      {/* Stock Management Section */}
      <div className={styles.stockManagementSection}>
        {/* <div className={styles.sectionHeader}>
          <h2>Stock Management</h2>
          <p>Manage chemical inventory and stock levels directly</p>
        </div> */}
      </div>

      {/* Stock Management Content */}
      <div className={styles.stockManagementContent}>
        <ChemicalManagement />
      </div>
    </div>
  );
} 